import { Component, Input, ComponentFactoryResolver, OnInit } from '@angular/core';

import {
  IOrderDelivery,
  IOrderRequest,
  CHAT_MESSAGE_TYPE,
  filterRequestDetails,
  isAnswerRequestDetail,
  IRequestQuestionDetail,
  REQUEST_QUESTION_TYPES,
  getRequestDetailAnswer,
  hasDeliveryDetails,
  ORDER_DELIVERY_METHODS,
  IRequestQuestionAnswerDetail,
  CieUtilsModalManagerService,
  IUploadImageRequestQuestionDetail,
  IMultipleChoiceRequestQuestionDetail, IIntegratedProductQuestionDetail, IRequestedProductQuestionDetail,
} from '@cakeiteasy/web-utils';

import { UiFullSizeImageComponent } from '../../modals/ui-full-size-image/ui-full-size-image.component';

type IUiDetailsPinnedMsgItem =
  | IMultipleChoiceRequestQuestionDetail
  | IUploadImageRequestQuestionDetail
  | (IRequestQuestionAnswerDetail & { answer: string })
  | IIntegratedProductQuestionDetail
  | IRequestedProductQuestionDetail;

@Component({
  standalone: false,
  selector: 'ui-details-pinned-msg',
  templateUrl: './ui-details-pinned-msg.component.html',
  styleUrls: [ './ui-details-pinned-msg.component.scss' ]
})
export class UiDetailsPinnedMsgComponent implements OnInit {
  @Input() orderRequest: IOrderRequest;
  @Input() deliveryOrder: IOrderDelivery;
  @Input() messageType: CHAT_MESSAGE_TYPE;
  @Input() requestCreatedDate: Date;

  public requestDetails: IUiDetailsPinnedMsgItem[] = [];

  public showDeliveryDetails: boolean;
  public isToDoor: boolean;
  public isPickup: boolean;

  public CHAT_MESSAGE_TYPE = CHAT_MESSAGE_TYPE;
  public REQUEST_QUESTION_TYPES = REQUEST_QUESTION_TYPES;

  constructor(private _modalManager: CieUtilsModalManagerService,
              private _componentResolver: ComponentFactoryResolver) {
  }

  ngOnInit(): void {
    const details = this.orderRequest ? this.orderRequest.details : [];

    this.requestDetails = filterRequestDetails(details)
      .map((detail) => this._mapRequestDetail(detail));

    // a NO_DELIVERY order has neither an address nor a delivery date to pin
    this.showDeliveryDetails = hasDeliveryDetails(this.deliveryOrder);
    this.isToDoor = this.showDeliveryDetails && this.deliveryOrder.type === ORDER_DELIVERY_METHODS.DELIVERY_TO_DOOR;
    this.isPickup = this.showDeliveryDetails && this.deliveryOrder.type === ORDER_DELIVERY_METHODS.PICKUP;
  }

  public showImage(imgUrl: string): void {
    this._modalManager
      .show(UiFullSizeImageComponent, this._componentResolver, { imgUrl }, {
        windowClass: 'full-size-image-modal'
      })
      .catch(() => {
      });
  }

  private _mapRequestDetail(detail: IRequestQuestionDetail): IUiDetailsPinnedMsgItem {
    if (!isAnswerRequestDetail(detail)) {
      return detail;
    }

    return {
      ...detail,
      answer: getRequestDetailAnswer(detail)
    };
  }
}
